const codes = {
    login: {
        1: '로그인에 실패하였습니다.'
    },
    usertype: {
        1: '$vuetify.tvsm.usertype.1',
        2: '$vuetify.tvsm.usertype.3',
        3: '$vuetify.tvsm.usertype.2'
    },
    langs: [
        {en: 'Spanish', on: 'Español', cd: 'es'},
        {en: 'English', on: 'English', cd: 'en'},
        {en: 'Korean', on: '한국어', cd: 'ko'}
    ]
}

const CodeService = (ckey, vkey) => {
    // TODO: String format 추가
    if (codes[ckey]) {
        if (codes[ckey][vkey]) return codes[ckey][vkey]
        else if (codes[ckey]) return codes[ckey]
        else return null
    }
    return null
}


export default CodeService